import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const votingImporterSelectors = importerSelectors(
  'voting.importer',
);

export default votingImporterSelectors;
